// extracted by mini-css-extract-plugin
export default {"frameWrapper":"cpm-profile-sponsorship-pixels-sponsorPixels__frameWrapper--2Iw_p"};